import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles<void, 'image' | 'link'>()((_theme, _, classes) => ({
	image: {
		height: 'auto',
		objectFit: 'contain',
	},
	fullWidthImage: {
		[`.${classes.image}`]: {
			bottom: 'auto !important',
			right: 'auto !important',
			top: '50% !important',
			left: '50% !important',
			objectFit: 'cover',
			objectPosition: '0 50%',
			width: '100%',
		},
		[`.${classes.link}`]: {
			width: '100%',
		},
	},
	imageWrapper: {
		display: 'flex',
		justifyContent: 'center',
		maxWidth: '1200px',
		maxHeight: '300px',
		overflow: 'hidden',
	},
	link: {
		display: 'flex',
		justifyContent: 'center',
	},
}));
